module.exports = __webpack_public_path__ + "media/images/athletes/1441-69f38dc0c79052803f3de1008caa52c9.png";